require('./contractLoanPdfViewerError.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { FormattedText } = require('core/i18n').i18n;

//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');

//@constants
const { EASY_LOAN_MAILTYPE } = require('constants/index');


const ContractLoanPdfViewerError = (props) => {

    const poeditorPrefix = 'contractEasyLoanStepThree';

    const handleButtonClick = () => {
        const { getDocuments, overdraftFlag, operationProcessId } = props;
        overdraftFlag ? getDocuments(true): getDocuments(EASY_LOAN_MAILTYPE.PRECONTRACTUAL,operationProcessId);
    }

    return (
        <div className="contract-loan-pdf-viewer-error">
            <i className="contract-loan-pdf-viewer-error__icon-error" />
            <span className="contract-loan-pdf-viewer-error__message">
                <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_legalDocumentsFirstErrorMessage`} />
            </span>
            <span className="contract-loan-pdf-viewer-error__message">
                <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_legalDocumentsSecondErrorMessage`} />
            </span>
            <div className="contract-loan-pdf-viewer-error__button">
                <OKButton
                    onClick={handleButtonClick}
                    modifier="secondary"
                >
                    <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_legalDocumentsButtonErrorText`} />
                </OKButton>
            </div>
            <span className="contract-loan-pdf-viewer-error__contact-message">
                <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_legalDocumentsContactMessage`} />
                <span className="contract-loan-pdf-viewer-error__contact-number">
                    <FormattedText value={`${poeditorPrefix}-${poeditorPrefix}_legalDocumentsContactNumber`} />
                </span>
            </span>
        </div>
    );
};

ContractLoanPdfViewerError.propTypes = {
    getDocuments: PropTypes.func.isRequired,
    overdraftFlag: PropTypes.bool,
    operationProcessId: PropTypes.string
};

ContractLoanPdfViewerError.defaultProps = {
    overdraftFlag: false,
    operationProcessId: ''
};

module.exports = ContractLoanPdfViewerError;
